import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import CopyCode from "./CopyCode";

export function forumUrl(url: string) {
  const value = url.trim();
  return /^(https?:\/\/|mailto:)/i.test(value) ||
    /^\/(?!\/)/.test(value) ||
    value.startsWith("#")
    ? value
    : "";
}

/** Community text stays data. No raw HTML, executable MDX, or remote image loads. */
export default function ForumMarkdown({ body }: { body: string }) {
  return (
    <div className="min-w-0 break-words text-[15px] leading-7 [&_p]:my-3 [&_p]:whitespace-pre-wrap [&_h2]:mb-3 [&_h2]:mt-7 [&_h2]:text-xl [&_h2]:font-semibold [&_h3]:mb-2 [&_h3]:mt-5 [&_h3]:font-semibold [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-1 [&_blockquote]:my-4 [&_blockquote]:border-l-2 [&_blockquote]:border-primary/60 [&_blockquote]:pl-4 [&_blockquote]:text-muted-foreground [&_a]:break-all [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_code]:rounded [&_code]:bg-muted/60 [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.85em] [&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_hr]:my-6 [&_hr]:border-border [&_strong]:font-semibold">
      <Markdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        urlTransform={forumUrl}
        components={{
          h1: ({ children }) => <h2>{children}</h2>,
          a: ({ href, children }) =>
            href ? (
              <a
                href={href}
                target={href.startsWith("#") ? undefined : "_blank"}
                rel="ugc nofollow noopener noreferrer"
              >
                {children}
              </a>
            ) : (
              <span>{children}</span>
            ),
          img: ({ src, alt }) =>
            typeof src === "string" && src ? (
              <a
                href={src}
                target="_blank"
                rel="ugc nofollow noopener noreferrer"
              >
                Image: {alt || "open attachment"}
              </a>
            ) : (
              <span>{alt}</span>
            ),
          pre: ({ children }) => <CopyCode>{children}</CopyCode>,
          table: ({ children }) => (
            <div className="my-5 max-w-full overflow-x-auto rounded-lg border border-border">
              <table className="w-full border-collapse text-sm [&_th]:bg-muted/50 [&_th]:p-3 [&_th]:text-left [&_td]:border-t [&_td]:border-border [&_td]:p-3">
                {children}
              </table>
            </div>
          ),
        }}
      >
        {body}
      </Markdown>
    </div>
  );
}
